export const warmrustic = {
  name: 'Warm & Rustic',
  color: [0.9921568627450981, 0.592156862745098, 0.30980392156862746, 1],
  bg: [0.996078431372549, 0.9490196078431372, 0.8941176470588236, 1],
  grid1: [0.7764705882352941, 0, 0, 1],
  grid2: [0.5019607843137255, 0.35294117647058826, 0.23137254901960785, 1],
}
